import React from 'react'
import VidableAPI from '../apiClient'
import { useAuth } from '../auth/AuthProvider'

const useApi = (): VidableAPI | undefined => {

    const auth = useAuth()
    const [client, setClient] = React.useState<VidableAPI>()

    React.useEffect(() => {
        
        if (auth?.user) {
            const jwtToken = auth.user.signInUserSession.idToken.jwtToken
            const clientInstance = new VidableAPI('/api/', jwtToken)
            setClient(clientInstance)
        }
    }, [auth])

    return client
}

export default useApi